<template>
  <div class="form-group" data-id="form-json">
    <label data-id="label-title" for="">{{ field.label}}</label>
      <span v-if="field.required" class="required-field" data-id="required" >*</span>
    <codemirror v-model="field.value" :options="cmOptionsJS"></codemirror>
  </div>
</template>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import VueEvents from "vue-events";
import { codemirror } from "vue-codemirror";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/markdown/markdown.js";
import "codemirror/theme/base16-light.css";
import "codemirror/addon/mode/overlay.js";
import "codemirror/addon/edit/matchbrackets.js";
import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/edit/matchtags.js";
import "codemirror/addon/lint/lint.js";

window.jsonlint = "codemirror/addon/lint/json-lint.js";
import { JSHINT } from "jshint";

window.JSHINT = JSHINT;
import "codemirror/addon/lint/javascript-lint.js";

Vue.use(VueEvents);

export default {
  name: "form-json",
  props: ["FieldData", "config"],
  components: {
    codemirror: codemirror,
  },
  data() {
    return {
      uiStates: {
        message: "",
        messageClass: "",
      },
      field: this.FieldData,
      cmOptionsJS: {
        tabSize: 4,
        mode: "application/json",
        theme: "default",
        lineNumbers: true,
        line: true,
        matchBrackets: true,
        matchTags: true,
        autoCloseBrackets: true,
        autoCloseTags: true,
        extraKeys: { "Ctrl-Space": "autocomplete" },
        lint: true,
        gutters: ["CodeMirror-lint-markers"],
      },
    };
  },
  mounted() {
    this.$emit("input", this.field.value);

    if (this.config != null) {
      this.cmOptionsJS = this.config;
    }
  },
  created() {},
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.required-field {
  font-size: 16px;
  color: #ab5755;
  position: absolute;
  top: -4px;
}
label {
  position: relative;
}
</style>
